var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "../../App/styles/HomeAdmin.css";
function HomeAdmin() {
    var _a = useState(''), displayedText = _a[0], setDisplayedText = _a[1];
    var _b = useState(0), currentIndex = _b[0], setCurrentIndex = _b[1];
    var fullText = "Seja bem-vindo(a) \u00E0 plataforma Celetihub";
    var typingSpeed = 80;
    var pauseTime = 2000;
    useEffect(function () {
        if (currentIndex < fullText.length) {
            var timeout_1 = setTimeout(function () {
                setDisplayedText(fullText.slice(0, currentIndex + 1));
                setCurrentIndex(function (prev) { return prev + 1; });
            }, typingSpeed);
            return function () { return clearTimeout(timeout_1); };
        }
        else {
            var restartTimeout_1 = setTimeout(function () {
                setDisplayedText('');
                setCurrentIndex(0);
            }, pauseTime);
            return function () { return clearTimeout(restartTimeout_1); };
        }
    }, [currentIndex, fullText]);
    function renderText() {
        var text = displayedText;
        var textStartIndex = fullText.indexOf('Celetihub');
        if (text.length > textStartIndex) {
            var beforeText = text.substring(0, textStartIndex);
            var textPart = text.substring(textStartIndex);
            return (_jsxs(_Fragment, { children: [beforeText, _jsx("span", __assign({ className: "text-highlight" }, { children: textPart }))] }));
        }
        return text;
    }
    return (_jsx("div", __assign({ className: "container-home" }, { children: _jsxs("h2", { children: [renderText(), currentIndex < fullText.length && (_jsx("span", __assign({ className: "cursor-home" }, { children: "|" })))] }) })));
}
export default HomeAdmin;
